import { log } from "../../utils";
import { ChatServerAsyncActionType } from "../../utils/useChatServerDispatch";
import { ChatState } from "../ChatState";
import { ChatDispatch } from "./types";

export default function sendGreeting(PRECHAT_FORM_ENABLED = false): ChatServerAsyncActionType {
    return chatServer => (dispatch: ChatDispatch, getState: () => ChatState) => {
        if (!PRECHAT_FORM_ENABLED) {
            const state = getState();
            if (!state.connection.greetingRequested) {
                log("sending greeting");
                // Send nothing to get the greeting content
                chatServer.sendChatMsg({ text: undefined, attributes: { isGreeting: true } }, (err2?: Error) => {
                    if (err2) {
                        log("Error sending message");
                    }
                    dispatch({
                        type: "sendGreeting",
                        detail: undefined
                    })
                });
            }
        }
    }
}